import theme from '../../../styles/theme.mjs';
import { StyledVideoControlIconButtonContainer } from '../VideoControlIconButton/VideoControlIconButton.styles.mjs';
import styled from 'styled-components';

const getIconPosition = (iconType) => {
    switch (iconType) {
        case 'backward': {
            return {
                md: { columns: 'repeat(5, 1fr)', justifySelf: 'right' },
                sm: { columns: '3fr 5fr 3fr', justifySelf: 'right' }
            };
        }
        case 'forward': {
            return {
                md: { columns: 'repeat(5, 1fr)', direction: 'rtl', justifySelf: 'left' },
                sm: { columns: '3fr 5fr 3fr', direction: 'rtl', justifySelf: 'left' }
            };
        }
        default: {
            return { md: { columns: '1fr' }, sm: { columns: '1fr' } };
        }
    }
};
const StyledVideoContainer = styled.div `
  position: relative;
  display: grid;
  width: 100%;
  height: 100%;
  grid-template-columns: ${props => { var _a; return (_a = getIconPosition(props.iconType).sm.columns) !== null && _a !== void 0 ? _a : 'auto'; }};
  ${props => !props.disableAspectRatio && `aspect-ratio: 16 / 9;`}
  background-color: ${props => (props.transparent ? 'transparent' : props.theme.colors.black)};
  padding: 0;
  outline: none;
  direction: ${props => { var _a; return (_a = getIconPosition(props.iconType).sm.direction) !== null && _a !== void 0 ? _a : 'inherit'; }};

  > ${StyledVideoControlIconButtonContainer} {
    ${props => (props.iconType === 'forward' || props.iconType === 'backward') && `direction: 'rtl'`};
    justify-self: ${props => { var _a; return (_a = getIconPosition(props.iconType).sm.justifySelf) !== null && _a !== void 0 ? _a : 'center'; }};
    transition: visibility
      ${props => (props.showOverlayIcon ? '0s' : props => props.theme.animation.duration.gentle1)}
      ${props => props.theme.animation.easing.expressive.standard};
    visibility: ${props => (props.showOverlayIcon ? 'visible' : 'hidden')};
  }

  @media screen and (min-width: ${theme.breakpoints.md}) {
    grid-template-columns: ${props => { var _a; return (_a = getIconPosition(props.iconType).md.columns) !== null && _a !== void 0 ? _a : 'auto'; }};

    ${StyledVideoControlIconButtonContainer} {
      justify-self: ${props => { var _a; return (_a = getIconPosition(props.iconType).md.justifySelf) !== null && _a !== void 0 ? _a : 'center'; }};
    }
  }
`;

export { StyledVideoContainer as default };
//# sourceMappingURL=VideoContainer.styles.mjs.map
